import { Observable } from "rxjs";
import { Store } from "@karma-games/angular-devkit/src/lib/extended-store";
import { selectMyBetsList, statisticsLastModified, statisticsReachedLastPageFlag } from "./statistics.selectors";
import { IRoundBet } from "../../core/round/interfaces";

declare module "@ngrx/store/src/store" {
    interface Store<T> {
        subscribeMyBetsList(): Observable<IRoundBet[]>;
        selectStatisticsReachedLastPageFlag(): boolean;
        subscribeStatisticsReachedLastPageFlag(): Observable<boolean>;
        subscribeStatisticsLastModified(): Observable<number>;
    }
}

function subscribeMyBetsList(this: Store): Observable<IRoundBet[]> {
    return this.select(selectMyBetsList);
}

function selectStatisticsReachedLastPageFlag(this: Store): boolean {
    return this.selectSync(statisticsReachedLastPageFlag);
}

function subscribeStatisticsReachedLastPageFlag(this: Store): Observable<boolean> {
    return this.select(statisticsReachedLastPageFlag);
}

function subscribeStatisticsLastModified(this: Store): Observable<number> {
    return this.select(statisticsLastModified);
}

Store.prototype.subscribeMyBetsList = subscribeMyBetsList;
Store.prototype.selectStatisticsReachedLastPageFlag = selectStatisticsReachedLastPageFlag;
Store.prototype.subscribeStatisticsReachedLastPageFlag = subscribeStatisticsReachedLastPageFlag;
Store.prototype.subscribeStatisticsLastModified = subscribeStatisticsLastModified;
